import { UiSchema } from '@rjsf/utils'

import { applyOtherDimensionValues } from '../utils/formSchema/otherDimensions'

export const uiSchema: UiSchema = {
    'ui:order': [
        'rimboard_material',
        'ewp_type',
        'joist_brand',
        'ijoist_ajs_dimensions',
        'ijoist_bci_dimensions',
        'ijoist_lpi_dimensions',
        'ijoist_pwi_dimensions',
        'ijoist_tji_dimensions',
        'i-joist_ajs_series',
        'i-joist_bci_series',
        'i-joist_lpi_series',
        'i-joist_pwi_series',
        'i-joist_tji_series',

        'dimensional_rimboard_dimensions',
        'ewp_nonosb_rimboard_dimensions',
        'ewp_osb_rimboard_dimensions',
        'i-joist_rimboard_dimensions',

        'rimboard_other_thickness',
        'rimboard_other_width',

        'rimboard_plies',
        'rimboard_other_plies',
        'sheathing',
    ],
    rimboard_material: {
        'ui:placeholder': 'Select Rimboard Material',
    },
    ewp_type: {
        'ui:placeholder': 'Select EWP Type',
    },
    joist_brand: {
        'ui:placeholder': 'Select I-Joist Type',
    },
    'i-joist_ajs_series': {
        'ui:placeholder': 'Select AJS Series',
    },
    'i-joist_bci_series': {
        'ui:placeholder': 'Select BCI Series',
    },
    'i-joist_lpi_series': {
        'ui:placeholder': 'Select LPI Series',
    },
    'i-joist_pwi_series': {
        'ui:placeholder': 'Select PWI Series',
    },
    'i-joist_tji_series': {
        'ui:placeholder': 'Select TJI Series',
    },
    ijoist_ajs_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    ijoist_bci_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    ijoist_lpi_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    ijoist_pwi_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    ijoist_tji_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    dimensional_rimboard_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    ewp_nonosb_rimboard_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    ewp_osb_rimboard_dimensions: {
        'ui:field': 'LumberDimensionsField',
    },
    'i-joist_rimboard_dimensions': {
        'ui:field': 'LumberDimensionsField',
    },
    rimboard_other_thickness: {
        'ui:title': 'Other Thickness',
        'ui:placeholder': 'Enter Other Thickness',
    },
    rimboard_other_width: {
        'ui:title': 'Other Width',
        'ui:placeholder': 'Enter Other Width',
    },
    rimboard_plies: {
        'ui:title': 'Plies',
        'ui:placeholder': 'Select Plies',
    },
    rimboard_other_plies: {
        'ui:title': 'Other Plies',
        'ui:placeholder': 'Enter Other Plies',
    },
    sheathing: {
        'ui:title': 'Rimboard Sheathing',
        'ui:field': 'SwitchField',
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    let newSettings = { ...settings, ...formData }

    if (newSettings.rimboard_material !== 'I-JOIST') {
        delete newSettings['joist_brand']
        delete newSettings['series']
        delete newSettings['ijoist_beam_dimensions']
    }

    newSettings = applyOtherDimensionValues(newSettings, {
        dimensionsKey: 'dimensional_rimboard_dimensions',
        thicknessOtherKey: 'rimboard_other_thickness',
        widthOtherKey: 'rimboard_other_width',
        shouldConvertFractions: true,
    })

    if (newSettings.ewp_type === 'OSB') {
        if (newSettings.ewp_osb_rimboard_dimensions) {
            newSettings.ewp_rimboard_dimensions = newSettings.ewp_osb_rimboard_dimensions
        }
    } else {
        newSettings.ewp_osb_rimboard_dimensions = null
        newSettings.ewp_rimboard_dimensions = newSettings.ewp_nonosb_rimboard_dimensions
    }

    newSettings = applyOtherDimensionValues(newSettings, {
        dimensionsKey: 'ewp_rimboard_dimensions',
        thicknessOtherKey: 'rimboard_other_thickness',
        widthOtherKey: 'rimboard_other_width',
        shouldConvertFractions: true,
    })

    if (newSettings.rimboard_plies === 'other' && newSettings.rimboard_other_plies) {
        newSettings.rimboard_plies = newSettings.rimboard_other_plies
    }
    newSettings.rimboard_other_plies = null
    if (newSettings.joist_brand === 'LPI') {
        newSettings.series = newSettings['i-joist_lpi_series']
        newSettings.ijoist_beam_dimensions = newSettings.ijoist_lpi_dimensions
        delete newSettings.ijoist_lpi_dimensions
        delete newSettings['i-joist_lpi_series']
    }
    if (newSettings.joist_brand === 'BCI') {
        newSettings.series = newSettings['i-joist_bci_series']
        newSettings.ijoist_beam_dimensions = newSettings.ijoist_bci_dimensions
        delete newSettings.ijoist_bci_dimensions
        delete newSettings['i-joist_bci_series']
    }
    if (newSettings.joist_brand === 'TJI') {
        newSettings.series = newSettings['i-joist_tji_series']
        newSettings.ijoist_beam_dimensions = newSettings.ijoist_tji_dimensions
        delete newSettings.ijoist_tji_dimensions
        delete newSettings['i-joist_tji_series']
    }
    if (newSettings.joist_brand === 'PWI') {
        newSettings.series = newSettings['i-joist_pwi_series']
        newSettings.ijoist_beam_dimensions = newSettings.ijoist_pwi_dimensions
        delete newSettings.ijoist_pwi_dimensions
        delete newSettings['i-joist_pwi_series']
    }
    if (newSettings.joist_brand === 'AJS') {
        newSettings.series = newSettings['i-joist_ajs_series']
        newSettings.ijoist_beam_dimensions = newSettings.ijoist_ajs_dimensions
        delete newSettings.ijoist_ajs_dimensions
        delete newSettings['i-joist_ajs_series']
    }

    return newSettings
}

const form = { uiSchema, onValidate, onSubmit }

export default form
